var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-0 mt-0 card card-table-loader vertical-center" },
    [
      _c(
        "div",
        {
          staticClass:
            "col-xl-2 col-lg-2 col-md-2 col-sm-2 vertical-center p-2",
        },
        [
          _c("b-skeleton", {
            staticClass: "mr-2 d-none d-md-block",
            attrs: { type: "avatar", width: "2.85rem", height: "2.85rem" },
          }),
          _vm._v(" "),
          _c("b-skeleton", { attrs: { width: "60%" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col-xl-2 col-lg-3 col-md-3 col-sm-3 vertical-center",
          staticStyle: { width: "15rem" },
        },
        [_c("b-skeleton", { attrs: { width: "100%" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xl-2 col-lg-2 col-md-2 col-sm-3 vertical-center" },
        [_c("b-skeleton", { attrs: { width: "100%" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xl-1 col-lg-1 col-md-2 col-sm-2 vertical-center" },
        [_c("b-skeleton", { attrs: { width: "100%" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xl-2 col-lg-2 col-md-2 col vertical-center" },
        [_c("b-skeleton", { attrs: { width: "100%" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "col d-none d-md-flex flex-row col-md-1 vertical-center",
          staticStyle: { width: "2rem" },
        },
        [_c("b-skeleton", { attrs: { width: "100%" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col d-none d-xl-flex flex-row justify-content-center align-items-center",
        },
        [
          _c("b-skeleton", {
            staticClass: "mx-auto",
            attrs: { width: "9rem", type: "button" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }